import { render, staticRenderFns } from "./ChartWeekly.vue?vue&type=template&id=dd0a13e6&"
import script from "./ChartWeekly.vue?vue&type=script&lang=js&"
export * from "./ChartWeekly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports